import React, { useState } from 'react';
import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import {
  COACH_MENU_LIST,
  isMenuClubDisabled,
  parseHiddenMenus,
} from '../../../lib/def/coachMenu';

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  width: 440px;
  max-height: 84vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

const Header = styled.div`
  padding: 18px 24px;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 1.15rem;
  font-weight: bold;
`;

const Desc = styled.div`
  padding: 16px 24px 4px 24px;
  font-size: 0.85rem;
  line-height: 1.5;
  color: ${palette.webGray[8]};
  word-break: keep-all;
`;

const List = styled.div`
  padding: 8px 24px 16px 24px;
  overflow-y: auto;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 4px;
  border-bottom: 1px solid ${palette.webGray[17]};

  & > span {
    font-size: 0.98rem;
    color: ${palette.webGray[13]};
  }
`;

const Toggle = styled.button`
  width: 46px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  background: ${(props) => (props.on ? palette.webCyan[5] : palette.webGray[6])};
  transition: background 0.15s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${(props) => (props.on ? '24px' : '2px')};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.15s;
  }

  &:focus {
    outline: none;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px 24px;
  border-top: 1px solid ${palette.webGray[17]};
`;

const Btn = styled.button`
  width: 100px;
  padding: 9px 0;
  border: 0;
  border-radius: 0.2rem;
  font-size: 0.95rem;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;

const CancelBtn = styled(Btn)`
  background: ${palette.webGray[5]};
  color: #fff;
`;

const SaveBtn = styled(Btn)`
  background: ${palette.webCyan[5]};
  color: #fff;
`;

const CoachMenuSettingModal = ({ coach, club, onClose, onSave }) => {
  // 클럽 플래그로 비활성인 메뉴는 설정에서 제외(자동 OFF + 숨김)
  const visibleMenus = COACH_MENU_LIST.filter((m) => !isMenuClubDisabled(m, club));
  const hiddenInit = parseHiddenMenus(coach && coach.webMenuHidden);

  // on(보임) 상태: 기본 전체 ON, hidden 목록에 있으면 OFF
  const [onMap, setOnMap] = useState(() => {
    const m = {};
    visibleMenus.forEach((menu) => {
      m[menu.key] = hiddenInit.indexOf(menu.key) === -1;
    });
    return m;
  });

  const toggle = (key) => setOnMap((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleSave = () => {
    // 현재 클럽 비활성이라 모달에 표시되지 않은(visibleMenus 에 없는) 기존 hidden key 는 보존한다.
    // (클럽 플래그가 다시 켜졌을 때 관리자가 이전에 숨겨둔 설정이 사라지지 않도록)
    const carried = hiddenInit.filter(
      (key) => visibleMenus.findIndex((menu) => menu.key === key) === -1,
    );
    // 표시된 메뉴 중 OFF 인 key + 보존 key 를 '%&' 로 join (빈 문자열 = 전체 노출)
    const off = visibleMenus
      .filter((menu) => !onMap[menu.key])
      .map((menu) => menu.key);
    onSave([...carried, ...off].join('%&'));
  };

  return (
    <Dim onClick={onClose}>
      <Box onClick={(e) => e.stopPropagation()}>
        <Header>{coach && coach.name ? `${coach.name} 강사` : '강사'} · 메뉴 표시 설정</Header>
        <Desc>
          CRM 접속 시 이 강사에게 보여줄 메뉴를 선택하세요. 끄면 좌측 메뉴에서 숨겨지고
          주소로 직접 접근하는 것도 차단됩니다.
        </Desc>
        <List>
          {visibleMenus.map((menu) => (
            <Row key={menu.key}>
              <span>{menu.text}</span>
              <Toggle
                type="button"
                on={onMap[menu.key] ? 1 : 0}
                onClick={() => toggle(menu.key)}
              />
            </Row>
          ))}
        </List>
        <Footer>
          <CancelBtn type="button" onClick={onClose}>
            취소
          </CancelBtn>
          <SaveBtn type="button" onClick={handleSave}>
            저장
          </SaveBtn>
        </Footer>
      </Box>
    </Dim>
  );
};

export default CoachMenuSettingModal;
